// extracted by mini-css-extract-plugin
export default {"skeleton":"styles_skeleton__88LLG","skeleton-appear":"styles_skeleton-appear__XKIBq","skeleton-pulse":"styles_skeleton-pulse__uX5oo"};